import { render, staticRenderFns } from "./syscs.vue?vue&type=template&id=4514e89c&scoped=true&"
import script from "./syscs.vue?vue&type=script&lang=js&"
export * from "./syscs.vue?vue&type=script&lang=js&"
import style0 from "./syscs.vue?vue&type=style&index=0&id=4514e89c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4514e89c",
  null
  
)

export default component.exports